import CommentsLoader from './CommentsLoader'

export default CommentsLoader
// eslint-disable-next-line import/export
export * from './CommentsLoader'
